import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=212153bc&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=212153bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212153bc",
  null
  
)

export default component.exports